import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { LoginComponent } from '../login/login.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard], // Use AuthGuard to handle redirection
    children: [
      {
        path: '',
        redirectTo: 'dashboard', // Redirect to 'dashboard' if logged in
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard], // Protect the dashboard route
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  // {
  //   path: '**',
  //   redirectTo: 'login', // Redirect any unknown paths to 'login'
  // },
  {
    path: 'patient-search',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('../components/components.module').then(m => m.ComponentsModule)
  },
  { path: '', redirectTo: 'patient-search', pathMatch: 'full' },
  {
    path: 'organization',
    //canActivate: [AuthGuard],
    loadChildren: () =>
      import('../components/components.module').then(m => m.ComponentsModule)
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)], // Use forRoot for the root routing module
  exports: [RouterModule] // Export RouterModule to make routes available in other modules
})
export class DashboardRoutingModule { }
